export enum MerchandiseClass {
  EXPLOSIVES = "1",
  GAS = "2",
  RADIOACTIVE = "7",
  CHEMICAL = "C",
  HYDROCARBONS = "H",
}
